import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getUserWithExpiry } from '../../services/authUtils';
import apiService from '../../services/apiService';
import NavBar from '../Common/NavBar';
import CopyrightInfo from '../Common/CopyrightInfo';
import ContactBanner from '../Common/ContactBanner';
import ProcessCard from '../Process/ProcessCard';
import PwaInstallPrompt from '../Common/PWAInstallPrompt';
import { gtmDashboardPageView, gtmProcessDataFetched, gtmProcessDataNotFound, gtmProcessDataFetchError } from '../../components/GtmEvents';


const Dashboard = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [processData, setProcessData] = useState(null);

    useEffect(() => {
        gtmDashboardPageView();

        const fetchProcessData = async () => {
            const user = getUserWithExpiry();
            if (!user) {
                navigate('/login');
                return;
            }
            setLoading(true);
            try {
                const initialData = await apiService.getProcessID(user.input, user.accessToken);
                if (initialData && initialData.proc_processes && initialData.proc_processes.length > 0) {
                    const processId = initialData.proc_processes[0].id;
                    const detailedProcessData = await apiService.fetchProcessDetails(processId);
                    localStorage.setItem('processId', processId);
                    localStorage.setItem('hapi_guid', detailedProcessData.hapi_guid || '');
                    setProcessData(detailedProcessData);  // Set processData as an object
                    gtmProcessDataFetched();

                    console.log("Fetched process data:", detailedProcessData);
                } else {
                    setError('No process data found.');
                    gtmProcessDataNotFound();
                }
            } catch (error) {
                console.error('Error fetching process data:', error);
                setError('Failed to load process data.');
                navigate('/login');
                gtmProcessDataFetchError();
            } finally {
                setLoading(false);
            }
        };
        fetchProcessData();
    }, [navigate]);

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return "Bom dia";
        if (hour < 20) return "Boa tarde";
        return "Boa noite";
    };

    return (
        <div>
            <NavBar />
            <PwaInstallPrompt />
            <div className="md:flex sm:block justify-center bg-[#F3F4F6] container-noNav">
                <div className="p-10 ml-5 mr-5 max-w-screen-xl md:w-full xs:p-4 xs:py-6">
                    <h2 className="text-xl font-bold mobile-spacing">{getGreeting()}, {processData ? processData.nameClient : ''}</h2>
                    <p className="pb-8">Nesta área pode aceder a todos os seus processos ou iniciar um novo com apenas um clique.</p>
                    <hr />
                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        processData ? (
                            <ProcessCard data={processData} />
                        ) : (
                            <p>No process data to display.</p>
                        )
                    )}
                    <div className="col-span-12">
                        <a
                            href="https://amco.pt"
                            target="_blank"
                            rel="noopener noreferrer"  // This adds security for external links
                        >
                            <button
                                type="button"
                                className="justify-center inline py-3 px-4 mt-4 border border-transparent rounded-md shadow-sm text-sm font-bold text-white amco-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:amco-blue/75 flex w-full"
                            >
                                Novo Pedido de Crédito
                            </button>
                        </a>
                    </div>
                    {error && <p className="text-red-500">{error}</p>}
                    <div className="hidden md:block">
                        <ContactBanner />
                    </div>
                    <CopyrightInfo />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
